import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MergeFieldFormInputTypes } from '@app/enums';
import { SigningTemplateSlot } from '@app/models/documents/signing-template-slot.model';
import { OfferLetter } from '@app/models/offer-letters/offer-letter.model';
import { SigningTemplateSlotNames } from '@app/modules/documents-v2/enums/signing-template-slot-names.enum';
import { MergeFieldFormInputAttributes } from '@app/modules/offer-letter/functions/offer-letter-field-form-input-attributes';
import { TemplateSlotNamesDisplayOptions } from '@app/types/translatables/template-slot-names-display.options';
import { BaseForm } from '@forms/base.form';

@Component({
    selector: 'app-review-candidate-information',
    templateUrl: './review-candidate-information.form.html',
    styleUrls: ['./review-candidate-information.style.scss'],
})
export class ReviewCandidateInformationForm extends BaseForm {
    @Input() offerLetter: OfferLetter = new OfferLetter();

    @Input() offerLetterHasCosigners = false;
    @Input() mergeFieldFormInputAttributes: MergeFieldFormInputAttributes[] = [];
    @Output() loading: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() offerLetterSent: EventEmitter<null> = new EventEmitter<null>();

    cosigners: SigningTemplateSlot[] = [];

    isLoading = false;
    mergeFieldFormInputTypes = MergeFieldFormInputTypes;
    signingTemplateSlotNames = SigningTemplateSlotNames;
    templateSlotNamesDisplayOptions = TemplateSlotNamesDisplayOptions;

    getDropdownOptionLabel(formInputAttribute: MergeFieldFormInputAttributes): string {
        const dropDownOption = this.offerLetter[formInputAttribute.attributeName];

        return dropDownOption[formInputAttribute.dropDownOptions.optionLabel] ?? '';
    }
}
